// Keyboard pads: pad 1 is bottom-left. Rows bottom→top: Z X C V / A S D F / Q W E R / 1 2 3 4.
// Uses `KeyboardEvent.code` so it works on any keyboard layout.
export const PAD_KEYS: readonly string[] = [
  "KeyZ",
  "KeyX",
  "KeyC",
  "KeyV",
  "KeyA",
  "KeyS",
  "KeyD",
  "KeyF",
  "KeyQ",
  "KeyW",
  "KeyE",
  "KeyR",
  "Digit1",
  "Digit2",
  "Digit3",
  "Digit4",
];

export const PAD_KEY_LABELS: readonly string[] = [
  "Z",
  "X",
  "C",
  "V",
  "A",
  "S",
  "D",
  "F",
  "Q",
  "W",
  "E",
  "R",
  "1",
  "2",
  "3",
  "4",
];

/** Pad index within the bank (0–15) for a key code, or -1. */
export function padForCode(code: string): number {
  return PAD_KEYS.indexOf(code);
}

export function keyVelocity(shift: boolean): number {
  return shift ? 127 : 100;
}

/** Velocity from the vertical click position in a pad (top = louder), optionally scaled by Force Touch. */
export function clickVelocity(yFraction: number, force?: number): number {
  const y = Math.min(1, Math.max(0, yFraction));
  let v = 127 - y * 87; // 127 at the top, 40 at the bottom
  if (force !== undefined && force > 1) v = Math.min(127, v * (1 + (force - 1) * 0.35));
  return Math.round(Math.max(1, Math.min(127, v)));
}
